import * as React from "react";
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import * as injectTapEventPlugin from "react-tap-event-plugin";
import { IntlProvider } from "react-intl";

import * as _ from "lodash";
import muiTheme from "muiTheme";
import baseLocale from "i18n/de";
import { observer, Provider } from "mobx-react";
import { User } from "models/User";
import { Loan } from "models/Loan";
import { Attachments } from "models/Attachment";
import { InterestRates } from "models/InterestRates";
import { auth } from "models/Auth";
import { Container } from "components/Container";
import { Route, HashRouter, RouteProps, Switch } from "react-router-dom";
import * as config from "config";

// Needed for onTouchTap click handlers 
// see http://stackoverflow.com/a/34015469/988941
injectTapEventPlugin();

const models = {
    user: new User(),
    loan: new Loan(),
    attachments: new Attachments(),
    interestRates: new InterestRates(),
    auth: auth
};


@observer
class App extends React.Component<{}, {}> {

    render() {
        if (!models.auth.isRehydrated
        ) {
            return <div />;
        }

        return (
            <Provider {...models}>
                <MuiThemeProvider muiTheme={muiTheme}>
                    <IntlProvider locale={config.LOCALE} messages={baseLocale}>
                        <HashRouter>
                            <Route path="/" component={Container as any} />
                        </HashRouter>
                    </IntlProvider>
                </MuiThemeProvider>
            </Provider>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/App.tsx